<template>
  <div ref="logoRef" class="logo" :class="{ active: active }">
    <div class="avro">
      <LogoA class="letter" />
      <LogoV class="letter" />
      <LogoR class="letter" />
      <LogoO class="letter" />
    </div>
    <div class="tros">
      <LogoT class="letter" />
      <LogoR class="letter" />
      <LogoO class="letter" />
      <LogoS class="letter" />
    </div>
  </div>
</template>

<script setup lang="ts">
const logoRef = ref<HTMLElement | undefined>(undefined);
const count = ref<number>(1);
const active = ref<boolean>(false);
const interval = ref<number | undefined>(undefined);

const map = [
  //a
  {
    from: {
      width: `${(337 / 833) * 100}%`,
      marginLeft: '0',
    },
    to: {
      width: `${(127 / 833) * 100}%`,
      marginLeft: '0',
    },
  },

  //v
  {
    from: {
      width: `${(262 / 833) * 100}%`,
      marginLeft: '-6.2%',
    },
    to: {
      width: `${(180 / 833) * 100}%`,
      marginLeft: '-4.7%',
    },
  },

  //r
  {
    from: {
      width: `${(160 / 833) * 100}%`,
      marginLeft: '-0.8%',
    },
    to: {
      width: `${(217 / 833) * 100}%`,
      marginLeft: '0.6%',
    },
  },

  //o
  {
    from: {
      width: `${(113 / 833) * 100}%`,
      marginLeft: '0',
    },
    to: {
      width: `${(318 / 833) * 100}%`,
      marginLeft: '1.5%',
    },
  },

  //t
  {
    from: {
      width: `${(282 / 833) * 100}%`,
      marginLeft: '0',
    },
    to: {
      width: `${(105 / 833) * 100}%`,
      marginLeft: '0',
    },
  },

  //r
  {
    from: {
      width: `${(219 / 833) * 100}%`,
      marginLeft: '2.7%',
    },
    to: {
      width: `${(157 / 833) * 100}%`,
      marginLeft: '1.3%',
    },
  },

  //o
  {
    from: {
      width: `${(175 / 833) * 100}%`,
      marginLeft: '1.3%',
    },
    to: {
      width: `${(242 / 833) * 100}%`,
      marginLeft: '1.2%',
    },
  },

  //s
  {
    from: {
      width: `${(100 / 833) * 100}%`,
      marginLeft: '1.3%',
    },
    to: {
      width: `${(269 / 833) * 100}%`,
      marginLeft: '1.6%',
    },
  },
];

const resize = (letters: HTMLElement[]) => {
  count.value = count.value === 0 ? 1 : 0;
  letters.forEach((letter, index) => {
    const relatedItem = map[index];
    if (relatedItem) {
      const newValue = count.value === 1 ? relatedItem.to : relatedItem.from;
      Object.assign(letter.style, newValue);
    }
  });
};

onMounted(() => {
  active.value = true;

  const letters = logoRef.value?.querySelectorAll('.letter') as never as HTMLElement[];
  resize(letters);
  interval.value = window.setInterval(
    () => {
      resize(letters);
      window.setTimeout(() => {
        resize(letters);
      }, 550);
    },
    10000 + Math.random() * 10000,
  );
});

onBeforeUnmount(() => {
  if (interval.value) {
    window.clearInterval(interval.value);
    interval.value = undefined;
  }
});
</script>

<style scoped lang="postcss">
.logo {
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  transform: scale(0.1);
  opacity: 0;
  transition:
    transform 0.25s ease-out,
    opacity 0.1s linear;

  aspect-ratio: 833/615;

  &.active {
    transform: scale(1);
    opacity: 1;
  }

  .avro {
    position: relative;
    display: flex;
    align-items: flex-end;
  }

  .tros {
    position: relative;
    display: flex;
    align-items: flex-start;
    margin-top: 2%;
  }

  .letter {
    transition:
      width 0.45s ease,
      height 0.45s ease,
      margin-left 0.45s ease;
  }
}
</style>
